import { Input } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useOutsideDetect } from "../../utils";
import DeleteIconButton from "../icons/DeleteIconButton";
import { SearchSVG } from "../icons/SVGIcon";
import ScrollWrapper from "../ScrollBar";
import "../ICDAutoComplete/style.scss";

const { Search } = Input;

const CPTAutoCompleteComponent = ({
  rows,
  options,
  query,
  title,
  handleSearch,
  loading,
  isResult,
  placeholder,
  disableSearchIcon,
  addItem,
  selectItem,
  removeItem,
  disableOptions,
  onclickRow,
  activeIndex,
  minRows,
  disabled,
  id,
  idAdd,
}) => {
  const ref = useRef(null);
  const ref1 = useRef(null);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [opData, setOpData] = useState([]);
  const [openResult, setOpenResult] = useState(false);
  const [removeable, setRemoveable] = useState(-1);
  const [activeSearch, setActiveSearch] = useState(-1);

  const data = rows ? rows : [];

  useEffect(() => {
    if (options && options.length > 0) {
      setOpData(options);
    } else {
      setOpData([]);
    }
  }, [options]);

  useEffect(() => {
    if (opData && opData.length > 0) {
      setActiveSearch(0);
    }
  }, [opData]);

  const minRowCount = minRows ? minRows : 4;

  let emptyRows = [];
  if (data.length < minRowCount + 1) {
    emptyRows = new Array(minRowCount - data.length).fill({ label: "" });
  }

  useOutsideDetect(ref, ref1, openResult, setOpenResult);
  
  useEffect(() => {
    setOpenResult(isResult);
  }, [isResult]);

  const handleSelectItem = (row) => {
    setSelected(row);
    setSearch(row.cpt_code_name || "");
    setOpenResult(false);
  };

  const addSelectedItem = () => {
    if (selectItem && selected) {
      selectItem(selected);
      setSelected(null);
      setSearch("");
    } else if (addItem) {
      addItem();
    }
  };

  const changeSearchInput = (e) => {
    setSearch(e.target?.value);
    if (handleSearch) {
      handleSearch(e.target?.value);
    }
  };

  const handleKeyPress = async () => {
    if (opData && opData[activeSearch]) {
      setSelected(opData[activeSearch]);
      setSearch(opData[activeSearch]?.cpt_code_name || "");
      setOpenResult(false);
      setActiveSearch(-1);
    }
  };

  const onKeyDown = (type) => {
    if (type === "down") {
      if (opData && opData[activeSearch + 1]) {
        setActiveSearch(activeSearch + 1);
      }
    } else {
      if (opData && opData[activeSearch - 1]) {
        setActiveSearch(activeSearch - 1);
      }
    }
  };

  const clickHandle = (row, index) => {
    if (onclickRow) {
      onclickRow(row, index);
    }
  };

  return (
    <div className="atuoComplete">
      <div className="atuoComplete__filter">
        <div ref={ref} className={`atuoComplete__filter-search ${disableSearchIcon ? "disable-icon" : ""}`}>
          <Search
            id={id ? id : "search_cpt"}
            value={search}
            placeholder={placeholder || "Search CPT Code"}
            onChange={changeSearchInput}
            onKeyDownCapture={(e) => {
              if (e.keyCode === 40) {
                onKeyDown("down");
              } else if (e.keyCode === 38) {
                onKeyDown("up");
              }
            }}
            onPressEnter={handleKeyPress}
            style={{ width: "100%" }}
            suffix={!disableSearchIcon ? <SearchSVG /> : null}
            onFocus={() => setOpenResult(true)}
            disabled={disabled}
          />
        </div>
        <div className={`atuoComplete__filter-action ${disabled ? "disabled" : ""}`}>
          <button 
            className="atuoComplete__filter-add" 
            onClick={addSelectedItem}
            disabled={disabled}
          >
            <span id={idAdd || "add_cpt"}>Add</span>
            <span>+</span>
          </button>
        </div>
        {!disableOptions && openResult && !!search && (
          <div style={{ zIndex: 1000 }} ref={ref1} className="atuoComplete__filter-result">
            <div className="atuoComplete__filter-result-list">
              <ScrollWrapper css="no-padding">
                {!!opData.length &&
                  opData.map((row, index) => {
                    return (
                      <div
                        className="atuoComplete__result-item"
                        key={`cpt-option-${row?.id}-${index}`}
                        onClick={() => handleSelectItem(row)}
                        style={{
                          backgroundColor: index === activeSearch ? "#DCE3EE" : "#fff",
                        }}
                      >
                        <p style={{ paddingLeft: "28px", whiteSpace: "pre" }}>
                          {row?.cpt_code_name || ""}
                        </p>
                      </div>
                    );
                  })}
              </ScrollWrapper>
            </div>
          </div>
        )}
      </div>

      <div className="atuoComplete__result" style={{ height: `calc(${(2.5 * minRowCount).toString()}rem + 4px)` }}>
        <ScrollWrapper css="no-padding x-hidden">
          <div className="atuoComplete__result-list">
            {data.map((row, index) => (
              <div
                className={`atuoComplete__result-item`}
                style={{
                  position: "relative",
                  paddingRight: "32px",
                  backgroundColor: activeIndex === index ? "#dbe3ee" : "#fff",
                }}
                key={`cpt-value-${row?.id}-${index}`}
                onClick={() => clickHandle(row, index)}
              >
                <div
                  style={{
                    display: "inline-flex",
                    marginRight: "0.5rem",
                    cursor: "pointer",
                    width: "100%",
                  }}
                >
                  <p style={{ marginLeft: 12 }}>{row?.cpt_code_name || ""}</p>
                </div>
                {!disabled && (
                  <div style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)" }}>
                    <DeleteIconButton
                      selected={removeable === index}
                      icon={"can"}
                      handleClick={() => {
                        if (removeable === index) {
                          removeItem(row, index);
                          setRemoveable(-1);
                        } else {
                          setRemoveable(index);
                        }
                      }}
                    />
                  </div>
                )}
              </div>
            ))}
            {emptyRows.map((row, index) => (
              <div className="atuoComplete__result-item empty" key={`cpt-empty-${index}`} />
            ))}
          </div>
        </ScrollWrapper>
      </div>
    </div>
  );
};

export default CPTAutoCompleteComponent;
